export const parseYearMonth = (dateString: string) => {
  if (!dateString || !dateString.includes('/')) {
    return { year: '', month: '' }
  }
  const splitted = dateString.split('/')
  const year = splitted[0]
  const month = splitted[1]
  return { year, month }
};

export const isValidYearMonth = (dateString: string) => {
  const { year, month } = parseYearMonth(dateString)

  if (!year || year === '西暦' || year === '0') return false
  if (!month || month === '月' || month === '0') return false

  const yearNum = parseInt(year, 10)
  const monthNum = parseInt(month, 10)
  if (isNaN(yearNum) || isNaN(monthNum) || monthNum < 1 || monthNum > 12) {
    return false
  }
  return true
};

export const parseDateToYearMonth = (dateStr: string | null) => {
  if (!dateStr) return { year: '', month: '' };
  const date = new Date(dateStr);
  return { year: String(date.getFullYear()), month: String(date.getMonth() + 1) };
};

export const formatYear = (dateStr: string | null): string => {
  if (!dateStr) return '';
  return String(new Date(dateStr).getFullYear());
};

export const formatMonth = (dateStr: string | null): string => {
  if (!dateStr) return '';
  return String(new Date(dateStr).getMonth() + 1);
};

export const formatDate = (dateStr: string | null): string => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  return `${year}/${String(month).padStart(2, '0')}`;
};

export const formatDateJP = (dateStr: string | null): string => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
};

export const formatYearMonthJP = (dateStr: string | null): string => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return `${date.getFullYear()}年${date.getMonth() + 1}月`;
};

export const formatPeriodJP = (startDate: string | null, endDate: string | null, currentWorking: boolean): string => {
  const start = startDate ? new Date(startDate) : null;
  const end = endDate ? new Date(endDate) : null;
  const startStr = start ? `${start.getFullYear()}年${start.getMonth() + 1}月` : '';
  const endStr = currentWorking ? '現在' : (end ? `${end.getFullYear()}年${end.getMonth() + 1}月` : '');
  return `${startStr} ~ ${endStr}`;
};

export const isEndAfterStart = (startStr: string, endStr: string) => {
  const { year: sY, month: sM } = parseYearMonth(startStr)
  const { year: eY, month: eM } = parseYearMonth(endStr)

  const startNum = parseInt(sY, 10) * 12 + parseInt(sM, 10)
  const endNum = parseInt(eY, 10) * 12 + parseInt(eM, 10)

  return endNum >= startNum
};
